// extracted by mini-css-extract-plugin
module.exports = {"info_txt":"InfoTxt_info_txt__2kl-m"};